(function () {
  try {
    var cfg = window.WHOLESALE_CONFIG || {};
    var WHOLESALE_PATH = String(cfg.path || "/en-wholesale").toLowerCase();

    function onWholesalePath() {
      return location.pathname.toLowerCase().startsWith(WHOLESALE_PATH);
    }
    function hasWholesaleTag(tags) {
      if (!Array.isArray(tags)) return false;
      var set = new Set(tags.map(function (t) { return String(t).toLowerCase(); }));
      return set.has("wholesaler");
    }

    // Defensive: don't run on checkout
    if (location.pathname.indexOf("/checkout") === 0) return;

    var allowed = Boolean(cfg.isLoggedIn) && hasWholesaleTag(cfg.tags || []);
    var onWholesale = onWholesalePath();

    if (allowed) {
      if (!onWholesale) window.location.replace(cfg.path || "/en-wholesale");
    } else {
      if (onWholesale) window.location.replace("/");
    }
  } catch (e) {
    if (console && console.warn) console.warn("Wholesale redirect skipped:", e);
  }
})();

